// extracted by mini-css-extract-plugin
export default {"darkbackground":"CheckOut_darkbackground__aknkZ","Img":"CheckOut_Img__gbMPZ","button":"CheckOut_button__ynMvd","fixedcol":"CheckOut_fixedcol__R3JVf"};